// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IEmploymentProfileDto } from './IEmploymentProfileDto';
import {
    IEmploymentProfileDtoFromJSON,
    IEmploymentProfileDtoFromJSONTyped,
    IEmploymentProfileDtoToJSON,
    IEmploymentProfileDtoToJSONTyped,
} from './IEmploymentProfileDto';
import type { IInvestorProfileDto } from './IInvestorProfileDto';
import {
    IInvestorProfileDtoFromJSON,
    IInvestorProfileDtoFromJSONTyped,
    IInvestorProfileDtoToJSON,
    IInvestorProfileDtoToJSONTyped,
} from './IInvestorProfileDto';

/**
 * 
 * @export
 * @interface IQuestionnaireDto
 */
export interface IQuestionnaireDto {
    /**
     * 
     * @type {string}
     * @memberof IQuestionnaireDto
     */
    investment_type?: IQuestionnaireDtoInvestmentTypeEnum;
    /**
     * 
     * @type {IEmploymentProfileDto}
     * @memberof IQuestionnaireDto
     */
    employment_profile?: IEmploymentProfileDto;
    /**
     * 
     * @type {IInvestorProfileDto}
     * @memberof IQuestionnaireDto
     */
    investment_profile?: IInvestorProfileDto;
}

/**
* @export
* @enum {string}
*/
export enum IQuestionnaireDtoInvestmentTypeEnum {
    MANAGED = 'MANAGED',
    BROKERAGE = 'BROKERAGE',
    SELF_DIRECTED = 'SELF_DIRECTED'
}


/**
 * Check if a given object implements the IQuestionnaireDto interface.
 */
export function instanceOfIQuestionnaireDto(value: object): value is IQuestionnaireDto {
    return true;
}

export function IQuestionnaireDtoFromJSON(json: any): IQuestionnaireDto {
    return IQuestionnaireDtoFromJSONTyped(json, false);
}

export function IQuestionnaireDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IQuestionnaireDto {
    if (json == null) {
        return json;
    }
    return {
        
        'investment_type': json['investment_type'] == null ? undefined : json['investment_type'],
        'employment_profile': json['employment_profile'] == null ? undefined : IEmploymentProfileDtoFromJSON(json['employment_profile']),
        'investment_profile': json['investment_profile'] == null ? undefined : IInvestorProfileDtoFromJSON(json['investment_profile']),
    };
}

export function IQuestionnaireDtoToJSON(json: any): IQuestionnaireDto {
    return IQuestionnaireDtoToJSONTyped(json, false);
}

export function IQuestionnaireDtoToJSONTyped(value?: IQuestionnaireDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'investment_type': value['investment_type'],
        'employment_profile': IEmploymentProfileDtoToJSON(value['employment_profile']),
        'investment_profile': IInvestorProfileDtoToJSON(value['investment_profile']),
    };
}

